import { EUnitOfMeasure } from '../shared/enum';
import { TInputLoad } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureMetricLabel } from './enum';

export const distributedOverload: TInputLoad = 'distributedOverload';
export const hasSeismicLoads: TInputLoad = 'hasSeismicLoads';
export const horizontalSeismicLoad: TInputLoad = 'horizontalSeismicLoad';
export const verticalSeismicLoad: TInputLoad = 'verticalSeismicLoad';
export const minFsStaticConditions: TInputLoad = 'minFsStaticConditions';
export const minFsSeismicConditions: TInputLoad = 'minFsSeismicConditions';
export const drainEfficiency: TInputLoad = 'drainEfficiency';

export const loadPD = {
    [distributedOverload]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.kilonewtonPerSquareMeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.poundForcePerSquareFoot,
        },
    },
    [hasSeismicLoads]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [horizontalSeismicLoad]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [verticalSeismicLoad]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [minFsStaticConditions]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [minFsSeismicConditions]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [drainEfficiency]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};
